export const checkMobileAgent = () => {
  return /(iPhone|iPad|iPod|iOS|Android|WebOS|BlackBerry|Windows Phone)/i.test(
    window.navigator.userAgent,
  )
}
